export default __webpack_public_path__ + "static/borrower_img-53a6291a1c397962ea3b25bc6f135678.png";